import api from 'api'
import { z } from 'zod'

const vndlyCompanySchema = z.object({
  id: z.number(),
  name: z.string(),
})

export type VndlyCompany = z.infer<typeof vndlyCompanySchema>

const vndlyInstanceSchema = z.object({
  id: z.number(),
  instanceUrl: z.string(),
  companies: z.array(vndlyCompanySchema),
})

export type VndlyInstance = z.infer<typeof vndlyInstanceSchema>

const listVndlyInstancesResponseSchema = z.object({
  items: z.array(vndlyInstanceSchema),
})

export type ListVndlyInstancesResponse = z.infer<
  typeof listVndlyInstancesResponseSchema
>

export const listVndlyInstances =
  async (): Promise<ListVndlyInstancesResponse> => {
    const response = await api.get<ListVndlyInstancesResponse>(
      '/admin/vndly/instances'
    )
    return listVndlyInstancesResponseSchema.parse(response.data)
  }
